// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.framedImageWrap {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 26px;
}

.framedImage {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  max-width: 597px;
  border-radius: 16px;
}

.cornerAccent {
  position: absolute;
  width: 130px;
  height: 130px;
  background-color: #f2d38c;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 55% 100%, 55% 45%, 0 45%);
  z-index: 0;
}

.cornerAccent--top {
  top: 0;
  right: 0;
}

.cornerAccent--bottom {
  bottom: 0;
  left: 0;
  transform: rotate(180deg);
}

@media (max-width: 768px) {
  .cornerAccent {
    width: 90px;
    height: 90px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FramedImage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,oEAAoE;EACpE,UAAU;AACZ;;AAEA;EACE,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".framedImageWrap {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  padding: 26px;\n}\n\n.framedImage {\n  position: relative;\n  z-index: 1;\n  display: block;\n  width: 100%;\n  max-width: 597px;\n  border-radius: 16px;\n}\n\n.cornerAccent {\n  position: absolute;\n  width: 130px;\n  height: 130px;\n  background-color: #f2d38c;\n  clip-path: polygon(0 0, 100% 0, 100% 100%, 55% 100%, 55% 45%, 0 45%);\n  z-index: 0;\n}\n\n.cornerAccent--top {\n  top: 0;\n  right: 0;\n}\n\n.cornerAccent--bottom {\n  bottom: 0;\n  left: 0;\n  transform: rotate(180deg);\n}\n\n@media (max-width: 768px) {\n  .cornerAccent {\n    width: 90px;\n    height: 90px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
